export default __webpack_public_path__ + "static/123-b89c15de9c38b8691d81629c4bc782f9.jpg";